// 应用类型 下拉选项
export const objectSelect = [
  { text: '广告活动', id: 'campaign' },
  { text: '广告组', id: 'group' },
  { text: '关键词', id: 'keyword' },
  { text: '商品投放', id: 'manualTarget' },
  { text: '投放组', id: 'autoTarget' },
  { text: '广告位', id: 'placement' },
];
// 广告活跃状态
export const activeSelect = [
  { text: '活跃', id: 1 },
  { text: '不活跃', id: 0 },
];
// 自动化类型
export const autoSelect = [
  { text: '分时策略', id: 'strategy' },
  { text: '自动规则', id: 'autoRule' },
];
// 模板状态
export const templateSelect = [
  { text: '启动', id: 'enabled' },
  { text: '关闭', id: 'paused' },
  { text: '归档', id: 'archived' },
];
// 分时策略
export const strategySelect = [
  { text: '启动分时策略', id: 0 },
  { text: '停用分时策略', id: 1 },
  { text: '移除分时策略', id: 2 },
];
// 自动规则
export const ruleSelect = [
  { text: '启动自动规则', id: 'enabled' },
  { text: '停用自动规则', id: 'paused' },
  { text: '移除自动规则', id: 'archived' },
];

// 广告类型枚举
export const enumAdType = [
  { id: 'sp', text: '商品广告' },
  { id: 'sb', text: '品牌广告' },
  { id: 'sd', text: '展示广告' },
];

// 表格配置
export const tableColumns = [
  { id: 'marketName', header: '站点', field: 'marketName', width: '100px' },
  {
    id: 'adType',
    header: '广告类型',
    field: 'option:adType',
    width: '100px',
    options: enumAdType,
  },
  {
    id: 'objectName',
    header: '应用对象',
    field: 'slot:objectName',
    width: '340px',
    sortable: true,
  },
  {
    id: 'campaignName',
    header: '广告活动',
    field: 'slot:campaignName',
    minWidth: '200px',
    sortable: true,
  },
  {
    id: 'strategyObject',
    header: '分时策略',
    field: 'slot:strategyObject',
    minWidth: '180px',
  },
  {
    id: 'autoRuleObjectList',
    header: '自动规则',
    field: 'slot:autoRuleObjectList',
    minWidth: '200px',
  },
  { id: 'op', header: '操作', field: 'slot:op', width: '100px' },
];

export const state = {
  enabled: '已开启',
  paused: '已关闭',
  archived: '已删除',
}

export const objectAdsType = {
  campaign: '广告活动',
  group: '广告组',
  placement: '广告位',
  keyword: '关键词',
  manualTarget: '商品投放',
  autoTarget: '投放组',
  asinSearch: '搜索词-ASIN',
  keywordSearch: '搜索词-关键词',
}

// 添加分时策略
export const strategyMap = {
  campaign: 3,
  group: 1,
}

// 只能日志使用 用于自动规则到日志弹窗的转化
export const objectType = {
  campaign: 1,
  group: 2,
  placement: 3,
  keyword: 5,
  manualTarget: 8,
  autoTarget: 10,
}

export const AdStrategyStatusEnum = {
  OPEN: 0,
  CLOSE: 1,
  NO_ADD: 2,

  option: [
    {id: 0, text: '已开启'},
    {id: 1, text: '已关闭'},
    {id: 2, text: '未添加'},
  ],
};

export const AdStrategyEnum = {
  status: {
    template: {
      ENABLE: 0,
      PAUSE: 1,
      ARCHIVE: 2
    },
    object: {
      ENABLE: 0,
      PAUSE: 1,
    }
  },
  statusOption: {
    object: [
      {id: 0, text: '启用'},
      {id: 1, text: '暂停'},
    ]
  },
  opTypeOption: [
    {id: 1, text: '基础调整竞价'},
    {id: 0, text: '基础调整预算'},
    {id: 3, text: '分时调整竞价'},
    {id: 2, text: '分时调整预算'},
    {id: 5, text: '模板调整竞价'},
    {id: 4, text: '模板调整预算'},
    {id: 6, text: '新增策略'},
    {id: 7, text: '修改策略'},
    {id: 8, text: '删除策略'},
    {id: 9, text: '分时恢复基础价格'},
  ],
  adjustType: {
    bid: 0,
    budget: 1,
    placementBid: 2
  },
  adjustTypeOption: [
    {id: 0, text: '调整竞价'},
    {id: 1, text: '调整每日预算'},
    {id: 2, text: '调整广告位竞价'},
  ],
  triggerType: {
    time: 0
  },
  triggerTypeOption: [
    {id: 0, text: '按时间'},
  ],
  timeOption: {
    start: '00:00',
    step: '01:00',
    end: '24:00'
  },
  repeatOption: [
    {id: 0, text: '每天'},
    {id: 7, text: '周日'},
    {id: 1, text: '周一'},
    {id: 2, text: '周二'},
    {id: 3, text: '周三'},
    {id: 4, text: '周四'},
    {id: 5, text: '周五'},
    {id: 6, text: '周六'},
  ],
  bidForm: {
    adjustType: {
      PERCENT_ADD: 0,
      PERCENT_SUB: 1,
    },
    adjustTypeOption: [
      {id: 0, text: '增加%'},
      {id: 1, text: '减少%'},
    ]
  },
  budgetForm: {
    adjustType: {
      PERCENT_ADD: 0,
      VALUE_ADD: 2,
    },
    adjustTypeOption: [
      {id: 0, text: '增加%'},
      {id: 2, text: '增加'},
    ]
  },
  placementBidForm: {
    adjustType: {
      PERCENT_ADD: 0,
      PERCENT_SUB: 1,
      VALUE_ADD: 2,
      VALUE_SUB: 3,
    },
    adjustTypeOption: [
      {id: 0, text: '增加%'},
      {id: 1, text: '减少%'},
      {id: 2, text: '增加'},
      {id: 3, text: '减少'},
    ]
  },
  adjustForm:{
    adjustType:{
      PERCENT_ADD: 0,
      PERCENT_SUB: 1,
      VALUE_ADD: 2,
      VALUE_SUB: 3,
      VALUE_FIXED: 4
    },
    adjustTypeOption:[
      {id: 0, text: '提高（%）'},
      {id: 1, text: '降低（%）'},
      {id: 2, text: '提高（数值）'},
      {id: 3, text: '降低（数值）'},
      {id: 4, text: '直接设置为'},
    ],
  },

  objectType: {
    CAMPAIGN: 0,
    GROUP: 1,
    PLACEMENT: 2,
    KEYWORD: 3,
    PRODUCT_TARGET: 4,
    TARGET_GROUP: 5,
  },
  objectTypeOption: [
    {id: 0, text: '广告活动'},
    {id: 1, text: '广告组'},
    {id: 2, text: '广告位'},
    {id: 3, text: '关键词'},
    {id: 4, text: '商品投放'},
    {id: 5, text: '投放组'},
  ],
  templateType: {
    PUBLIC: 0,
    PRIVATE: 1,
    TEMPORARY: 2
  },
  //广告状态
  adStatusOption: [
    {id: 0, text: '活跃'},
    {id: 1, text: '不活跃'},
  ],
  //策略状态
  policyStatusOption: [
    {id: 0, text: '开启中'},
    {id: 1, text: '暂停中'},
  ],
  // 分时策略模板 结果通知 下拉框选项
  resultOption:[
    {id:2,text:'有错误时通知'},
    {id:1,text:'执行完成通知'},
    {id:0,text:'不通知'},
  ]
};

export const guideData = [
  {
      id: 1,
      title: "广告自动化全新上线啦～", // 标题
      text: '', // 文本
      list: [  // 段落文本
          "① 全新上线【自动规则】，您可以根据平时的调价调预算策略自定义成模板，系统给您自动执行；",
          "② 将分时策略，模板与自动规则模板合并为广告自动化；",
          "③ 可以在应用对象查看所有应用分时策略或自动规则的对象；",
      ],
      preBtn: '', //上一步按钮
      nextBtn: "下一步", // 下一步按钮
      closeBtn: '', // 完成按钮
      shadowCoord: {top: '40px', left: '0', width: '100%', height: '130px'}, // 阴影坐标
      textCoord: {top: '185px', left: '96px', width: '386px'} // 内容坐标
  },
  { // 表格内部需要单独计算
      id: 2,
      title: "分时策略",
      text: '可以对分时策略进行修改、新增、移除、开启、暂停',
      list: [],
      preBtn: '上一步',
      nextBtn: "下一步",
      closeBtn: '',
      shadowCoord: {},
      textCoord: {},
      computing: {tableClass: '.guide-table-object', elClass: '.guide-col-strategy', place: 'right'}, //配置了这个参数则会使用计算的方式去实现框选区域
  },
  { // 表格内部需要单独计算
      id: 3,
      title: "自动规则",
      text: '',
      list: [
          '① 可以将您的自动策略转化为自动规则，系统给您执行；',
          '② 可以添加多个自动规则；',
          '③ 可以对自动规则进行修改、新增、移除、开启、暂停；',
      ],
      preBtn: '上一步',
      nextBtn: "下一步",
      closeBtn: '',
      shadowCoord: {},
      textCoord: {},
      computing: {tableClass: '.guide-table-object', elClass: '.guide-col-rule', place: 'left'}, //配置了这个参数则会使用计算的方式去实现框选区域
  },
  {
      id: 4,
      title: "自动规则模板", // 标题
      text: '去自动规则模板列表创建模板吧！', // 文本
      list: [],
      preBtn: '上一步', //上一步按钮
      nextBtn: '下一步', // 下一步按钮
      shadowCoord: {top: '118px', left: '110px', width: '107px', height: '53px'}, // 阴影坐标
      textCoord: {top: '185px', left: '96px', width: '386px'}, // 内容坐标
      nextFn: (_this) => {
        _this.$emit('cutTab');
      }
  },
]